/**
 * Neon Slam's own theme variables: the neon world's (`NEON_TOKENS`), shared with Neon Pack.
 */
import { NEON_TOKENS } from "../neon/tokens";

export const NEON_SLAM_TOKENS = NEON_TOKENS;
